import {
    UPDATE_STOP_TRACKING_REASON,
    UPDATE_STOP_TRACKING_END_DATE,
    UPDATE_STOP_TRACKING_PREGNANCY_NOTES,
    UPDATE_STOP_TRACKING_CYCLE_TYPE,
    RESET_STOP_TRACKING,
    COMPLETE_STOP_TRACKING_START,
    COMPLETE_STOP_TRACKING_SUCCESS,
    COMPLETE_STOP_TRACKING_ERROR,
    TAKE_A_BREAK_START,
    TAKE_A_BREAK_SUCCESS,
    TAKE_A_BREAK_ERROR,
    RESET_TAKE_A_BREAK,
    RESET_SETUP,
    UPDATE_SETUP_DUE_DATE,
    UPDATE_DAILY_HYDRATION_GOAL,
    UPDATE_WEIGHT_GOAL_USER_INPUTS,
    UPDATE_INDEX_SCALE_ADVANCED_METRICS,
    ENABLE_MOVE_ALERTS,
    ENABLE_TRAINING_STATUS_ALERTS,
    INITIAL_PREGNANCY_CREATE_SUCCESS,
    INITIAL_PREGNANCY_CREATE_ERROR,
    INITIAL_PREGNANCY_HYDRATION_ERROR,
    INITIAL_PREGNANCY_TRAINING_STATUS_ERROR,
    INITIAL_PREGNANCY_CREATE_SEND,
    INITIAL_PREGNANCY_WEIGHT_GAIN_GOALS_ERROR,
    INITIAL_PREGNANCY_INDEX_SCALE_ERROR,
    INITIAL_PREGNANCY_MOVE_ALERT_ERROR,
    FETCH_PREGNANCY_SNAPSHOTS_SUCCESS,
    FETCH_PREGNANCY_SNAPSHOTS_FETCHING,
    FETCH_PREGNANCY_SNAPSHOTS_FAIL,
    UPDATE_PREGNANCY_SNAPSHOT_UPDATING,
    UPDATE_PREGNANCY_SNAPSHOT_SUCCESS,
    UPDATE_PREGNANCY_SNAPSHOT_FAIL,
    FETCH_PREGNANCY_DAYVIEW_FETCHING,
    FETCH_PREGNANCY_DAYVIEW_SUCCESS,
    FETCH_PREGNANCY_DAYVIEW_FAIL,
    UPDATE_PREGNANCY_DAILY_LOG_SUCCESS,
    UPDATE_PREGNANCY_DAILY_LOG_FAIL,
    FETCH_PREGNANCY_GLUCOSE_FETCHING,
    FETCH_PREGNANCY_GLUCOSE_SUCCESS,
    FETCH_PREGNANCY_GLUCOSE_FAIL,
    ADD_PREGNANCY_GLUCOSE_SUCCESS,
    ADD_PREGNANCY_GLUCOSE_FAIL,
    UPDATE_PREGNANCY_GLUCOSE_SUCCESS,
    UPDATE_PREGNANCY_GLUCOSE_FAIL,
    DELETE_PREGNANCY_GLUCOSE_SUCCESS,
    DELETE_PREGNANCY_GLUCOSE_FAIL,
    FETCH_PREGNANCY_ICON_SUCCESS,
    FETCH_PREGNANCY_ICON_FAIL,
    INITIAL_PREGNANCY_CREATE_CONFLICT_ERROR,
    FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_FETCHING,
    FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_SUCCESS,
    FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_FAIL
} from 'actions/pregnancyTrackingActions';

const INITIAL_STATE = {
    stopTracking: {
        stopTrackingType: null,
        endDate: null,
        pregnancyNotes: null,
        cycleType: null,
        updating: false,
        updatingFail: false,
        success: false
    },
    takeBreak: {
        updating: false,
        updatingFail: false,
        success: false
    },
    setup: {
        dueDate: null,
        title: null,
        hydrationGoal: null,
        updating: false,
        updatingFail: false,
        success: false,
        weightGoalUserInputs: {
            weightGoalRecommendation: false,
            heightInCm: null,
            weightInGram: null
        },
        advancedMetrics: {
            deviceId: null,
            advancedMetrics: []
        },
        moveAlerts: {
            deviceId: null,
            enabled: true
        },
        trainingStatusEnabled: null,
        send: false,
        success: false,
        setupError: false,
        hydrationError: false,
        trainingStatusError: false,
        weightGainError: false,
        dueDateError: false,
        indexScaleError: false,
        moveAlertError: false,
        conflictErrorCycleType: null,
        conflictPeriodStartDate: null
    },
    pregnancySnapshots: {
        snapshots: null,
        success: false,
        error: false,
        fetching: false,
        updating: false,
        updateSuccess: null,
        updateError: null
    },
    dayView: {
        data: null,
        fetching: false,
        success: false,
        error: false
    },
    dailyLog: {
        dayLog: null,
        success: false,
        error: false
    },
    glucose: {
        addSuccess: false,
        addError: false,
        data: null,
        fetching: false,
        success: false,
        error: false,
        updateSuccess: false,
        updateError: false,
        deleteSuccess: false,
        deleteError: false
    },
    pregnancyIcons: {
        icons: {},
        fetching: false,
        success: false,
        error: false
    },
    weightGainGoals: {
        data: null,
        fetching: false,
        success: false,
        error: false
    }
};

export const isPregnancyIconsSuccess = (state) => {
    return state.pregnancyTracking.pregnancyIcons.success;
};

export const pregnancyIcons = (state) => {
    return state.pregnancyTracking.pregnancyIcons.icons;
};

export const getStopTracking = (state) => {
    return state.pregnancyTracking.stopTracking;
};

export const isStopTrackingUpdating = (state) => {
    return state.pregnancyTracking.stopTracking.updating;
};

export const isStopTrackingUpdatingSuccess = (state) => {
    return state.pregnancyTracking.stopTracking.success;
};

export const isStopTrackingUpdatingFail = (state) => {
    return state.pregnancyTracking.stopTracking.updatingFail;
};

export const isTakeBreakUpdating = (state) => {
    return state.pregnancyTracking.takeBreak.updating;
};

export const isTakeBreakUpdatingSuccess = (state) => {
    return state.pregnancyTracking.takeBreak.success;
};

export const isTakeBreakUpdatingFail = (state) => {
    return state.pregnancyTracking.takeBreak.updatingFail;
};

export const setupDetail = (state) => {
    return state.pregnancyTracking.setup;
};

export const isPregnancySetupSuccess = (state) => {
    return state.pregnancyTracking.setup.success;
};

export const isPregnancySetupError = (state) => {
    return state.pregnancyTracking.setup.setupError;
};

export const getPregnancyConflictErrorCycleType = (state) => {
    return state.pregnancyTracking.setup.conflictErrorCycleType;
};

export const getPregnancyConflictErrorStartDate = (state) => {
    return state.pregnancyTracking.setup.conflictPeriodStartDate;
};

export const isPregnancySetupHydrationError = (state) => {
    return state.pregnancyTracking.setup.hydrationError;
};

export const isPregnancySetupTrainingStatusError = (state) => {
    return state.pregnancyTracking.setup.trainingStatusError;
};

export const isPregnancySetupTrainingSending = (state) => {
    return state.pregnancyTracking.setup.send;
};

export const isPregnancySetupDueDateError = (state) => {
    return state.pregnancyTracking.setup.dueDateError;
};

export const isPregnancySetupWeightGainGoalError = (state) => {
    return state.pregnancyTracking.setup.weightGainError;
};

export const isPregnancySetupIndexScaleError = (state) => {
    return state.pregnancyTracking.setup.indexScaleError;
};

export const isPregnancySetupMoveAlertError = (state) => {
    return state.pregnancyTracking.setup.moveAlertError;
};

export const getPregnancySnapshots = (state) => {
    return state.pregnancyTracking.pregnancySnapshots.snapshots;
};

export const isPregnancySnapshotsFetching = (state) => {
    return state.pregnancyTracking.pregnancySnapshots.fetching;
};

export const isPregnancySnapshotsSuccess = (state) => {
    return state.pregnancyTracking.pregnancySnapshots.success;
};

export const isPregnancySnapshotsError = (state) => {
    return state.pregnancyTracking.pregnancySnapshots.error;
};

export const isPregnancySnapshotUpdating = (state) => {
    return state.pregnancyTracking.pregnancySnapshots.updating;
};

export const isPregnancySnapshotUpdateSuccess = (state) => {
    return state.pregnancyTracking.pregnancySnapshots.updateSuccess;
};

export const isPregnancySnapshotUpdateError = (state) => {
    return state.pregnancyTracking.pregnancySnapshots.updateError;
};

export const getDayView = (state) => {
    return state.pregnancyTracking.dayView.data;
};

export const isDayViewFetching = (state) => {
    return state.pregnancyTracking.dayView.fetching;
};

export const isDayViewSuccess = (state) => {
    return state.pregnancyTracking.dayView.success;
};

export const isDayViewError = (state) => {
    return state.pregnancyTracking.dayView.error;
};

export const getDayLog = (state) => {
    return state.pregnancyTracking.dailyLog.dayLog;
};

export const isDayLogError = (state) => {
    return state.pregnancyTracking.dailyLog.error;
};

export const isDayLogSuccess = (state) => {
    return state.pregnancyTracking.dailyLog.success;
};

export const isGlucoseFetchSuccess = (state) => {
    return state.pregnancyTracking.glucose.success;
};

export const isGlucoseFetchError = (state) => {
    return state.pregnancyTracking.glucose.error;
};

export const getGlucose = (state) => {
    return state.pregnancyTracking.glucose.data;
};

export const isGlucoseAddSuccess = (state) => {
    return state.pregnancyTracking.glucose.addSuccess;
};

export const isGlucoseAddError = (state) => {
    return state.pregnancyTracking.glucose.addError;
};

export const isGlucoseUpdateSuccess = (state) => {
    return state.pregnancyTracking.glucose.updateSuccess;
};

export const isGlucoseUpdateError = (state) => {
    return state.pregnancyTracking.glucose.updateError;
};

export const isGlucoseDeleteSuccess = (state) => {
    return state.pregnancyTracking.glucose.deleteSuccess;
};

export const isGlucoseDeleteError = (state) => {
    return state.pregnancyTracking.glucose.deleteError;
};

export const getPregnancyWeightGainGoals = (state) => {
    return state.pregnancyTracking.weightGainGoals.data;
};

export const isPregnancyWeightGainGoalsFetching = (state) => {
    return state.pregnancyTracking.weightGainGoals.fetching;
};

export const isPregnancyWeightGainGoalsSuccess = (state) => {
    return state.pregnancyTracking.weightGainGoals.success;
};

export const isPregnancyWeightGainGoalsError = (state) => {
    return state.pregnancyTracking.weightGainGoals.error;
};

const updateStopTrackingReason = (state, action) => {
    return {
        ...state,
        stopTracking: {
            ...state.stopTracking,
            stopTrackingType: action.reason
        }
    };
};

const updateStopTrackingEndDate = (state, action) => {
    return {
        ...state,
        stopTracking: {
            ...state.stopTracking,
            endDate: action.endDate
        }
    };
};

const updateStopTrackingPregnancyNotes = (state, action) => {
    return {
        ...state,
        stopTracking: {
            ...state.stopTracking,
            pregnancyNotes: action.notes
        }
    };
};

const updateStopTrackingCycleType = (state, action) => {
    return {
        ...state,
        stopTracking: {
            ...state.stopTracking,
            cycleType: action.cycleType
        }
    };
};

const resetStopTracking = (state) => {
    return {
        ...state,
        stopTracking: INITIAL_STATE.stopTracking
    };
};

const stopTrackingUpdate = (submitted) => (state, action) => {
    return {
        ...state,
        stopTracking: {
            ...state.stopTracking,
            updating: submitted,
            success: !submitted
        }
    };
};

const stopTrackingUpdateFail = (state, action) => {
    return {
        ...state,
        stopTracking: {
            ...state.stopTracking,
            updating: false,
            updatingFail: true
        }
    };
};

const resetTakeBreak = (state) => {
    return {
        ...state,
        takeBreak: INITIAL_STATE.takeBreak
    };
};

const takeBreak = (submitted) => (state) => {
    return {
        ...state,
        takeBreak: {
            ...state.takeBreak,
            updating: submitted,
            success: !submitted
        }
    };
};

const takeBreakFail = (state) => {
    return {
        ...state,
        takeBreak: {
            ...state.takeBreak,
            updating: false,
            updatingFail: true
        }
    };
};

const resetSetup = (state) => {
    return {
        ...state,
        setup: INITIAL_STATE.setup
    };
};

const updateSetupDueDate = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            dueDate: action.dueDate,
            title: action.title
        }
    };
};

const updateHydrationGoal = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            hydrationGoal: action.hydrationGoal
        }
    };
};

const updateWeightGoalUserInputs = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            weightGoalUserInputs: action.weightGoalUserInputs
        }
    };
};

const updateIndexScaleAdvancedMetrics = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            advancedMetrics: action.advancedMetrics
        }
    };
};

const updatePregnancySnapshotUpdating = (state, action) => {
    return {
        ...state,
        pregnancySnapshots: {
            ...state.pregnancySnapshots,
            updating: true
        }
    };
};

const updatePregnancySnapshotSuccess = (success) => (state, action) => {
    let updatedSnapshots = [];

    if (success) {
        // Blend the existing snapshots with the updated snapshot
        // > or, if there's just one, update just that one
        if (state.pregnancySnapshots.snapshots.length > 1) {
            state.pregnancySnapshots.snapshots.forEach((snapshot) => {
                if (snapshot.originalDueDate === action.pregnancySnapshot.originalDueDate) {
                    updatedSnapshots.push(action.pregnancySnapshot);
                } else {
                    updatedSnapshots.push(snapshot);
                }
            });
        } else {
            updatedSnapshots.push(action.pregnancySnapshot);
        }
    }

    return {
        ...state,
        pregnancySnapshots: {
            ...state.pregnancySnapshots,
            snapshots: success ? updatedSnapshots : state.pregnancySnapshots.snapshots,
            updateSuccess: success,
            updateError: !success,
            updating: false
        }
    };
};

const enableMoveAlerts = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            moveAlerts: {
                deviceId: action.deviceId,
                enabled: action.enabled
            }
        }
    };
};

const enableTrainigStatusAlerts = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            trainingStatusEnabled: action.enableTrainingStatusAlerts
        }
    };
};

const createPregnancySend = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            send: true,
            success: false,
            setupError: false,
            hydrationError: false,
            trainingStatusError: false,
            weightGainError: false,
            dueDateError: false,
            indexScaleError: false,
            moveAlertError: false
        }
    };
};

const createPregnancySuccess = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            success: true,
            send: false,
            setupError: false,
            hydrationError: false,
            trainingStatusError: false,
            weightGainError: false,
            dueDateError: false,
            indexScaleError: false,
            moveAlertError: false,
            conflictErrorCycleType: null,
            conflictPeriodStartDate: null
        }
    };
};

const createPregnancyError = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            success: false,
            send: false,
            setupError: true,
            hydrationError: false,
            trainingStatusError: false,
            weightGainError: false,
            dueDateError: false,
            indexScaleError: false,
            moveAlertError: false,
            conflictErrorCycleType: null,
            conflictPeriodStartDate: null
        }
    };
};

const pregnancyConflictError = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            success: false,
            send: false,
            setupError: false,
            hydrationError: false,
            trainingStatusError: false,
            weightGainError: false,
            dueDateError: false,
            indexScaleError: false,
            moveAlertError: false,
            conflictErrorCycleType: action.conflictType,
            conflictPeriodStartDate: action.periodStartDate
        }
    };
};

const createPregnancyHydrationError = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            success: false,
            send: false,
            setupError: false,
            hydrationError: true,
            trainingStatusError: false,
            weightGainError: false,
            dueDateError: false,
            indexScaleError: false,
            moveAlertError: false
        }
    };
};

const createPregnancyTrainingStatusError = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            success: false,
            send: false,
            setupError: false,
            hydrationError: false,
            trainingStatusError: true,
            weightGainError: false,
            dueDateError: false,
            indexScaleError: false,
            moveAlertError: false
        }
    };
};

const createWeightGainGoalError = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            success: false,
            send: false,
            setupError: false,
            hydrationError: false,
            trainingStatusError: false,
            weightGainError: true,
            dueDateError: false,
            indexScaleError: false,
            moveAlertError: false
        }
    };
};

const createIndexScaleError = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            success: false,
            send: false,
            setupError: false,
            hydrationError: false,
            trainingStatusError: false,
            weightGainError: false,
            dueDateError: false,
            indexScaleError: true,
            moveAlertError: false
        }
    };
};

const createMoveAlertError = (state, action) => {
    return {
        ...state,
        setup: {
            ...state.setup,
            success: false,
            send: false,
            setupError: false,
            hydrationError: false,
            trainingStatusError: false,
            weightGainError: false,
            dueDateError: false,
            indexScaleError: false,
            moveAlertError: true
        }
    };
};

const pregnancySnapshotsSuccess = (success) => (state, action) => {
    return {
        ...state,
        pregnancySnapshots: {
            ...state.pregnancySnapshots,
            snapshots: success ? action.data : null,
            success: success,
            error: !success,
            fetching: false
        }
    };
};

const pregnancySnapshotsFetching = (state, action) => {
    return {
        ...state,
        pregnancySnapshots: {
            ...state.pregnancySnapshots,
            snapshots: null,
            fetching: true
        }
    };
};

const dayViewFetching = (state, action) => {
    return {
        ...state,
        dayView: {
            ...state.dayView,
            data: null,
            fetching: true
        }
    };
};

const dayViewSuccess = (success) => (state, action) => {
    return {
        ...state,
        dayView: {
            ...state.dayView,
            data: success ? action.data : null,
            fetching: false,
            success: success,
            error: !success
        },
        dailyLog: {
            ...state.dailyLog,
            dayLog: success ? action.data.dayLog : null
        }
    };
};

const dailyLogSuccess = (success) => (state, action) => {
    return {
        ...state,
        dailyLog: {
            ...state.dailyLog,
            dayLog: action.data,
            success: success,
            error: !success
        }
    };
};

const gluCoseFetching = (state, action) => {
    return {
        ...state,
        glucose: {
            ...state.glucose,
            fetching: true
        }
    };
};

const gluCoseFetchingSuccess = (success) => (state, action) => {
    return {
        ...state,
        glucose: {
            ...state.glucose,
            data: action.data,
            success: success,
            error: !success,
            fetching: false,
            addSuccess: false,
            addError: false
        }
    };
};

const glucoseAddSuccess = (success) => (state, action) => {
    return {
        ...state,
        glucose: {
            ...state.glucose,
            addSuccess: success,
            addError: !success,
            fetching: false,
            updateSuccess: false,
            updateError: false,
            deleteSuccess: false,
            deleteError: false
        }
    };
};

const glucoseUpdateSuccess = (success) => (state, action) => {
    return {
        ...state,
        glucose: {
            ...state.glucose,
            addSuccess: false,
            addError: false,
            deleteSuccess: false,
            deleteError: false,
            updateSuccess: success,
            updateError: !success,
            fetching: false
        }
    };
};

const glucoseDeleteSuccess = (success) => (state, action) => {
    return {
        ...state,
        glucose: {
            ...state.glucose,
            deleteSuccess: success,
            deleteError: !success,
            fetching: false,
            updateSuccess: false,
            updateError: false,
            addSuccess: false,
            addError: false
        }
    };
};

const pregnancyIconsSuccess = (success) => (state, action) => {
    return {
        ...state,
        pregnancyIcons: {
            ...state.pregnancyIcons,
            icons: {
                ...state.pregnancyIcons.icons,
                [action.data.iconKey]: action.data.iconData
            },
            success: success,
            error: !success
        }
    };
};

const pregnancyWeightGainGoalsFetching = (state, action) => {
    return {
        ...state,
        weightGainGoals: {
            ...state.weightGainGoals,
            data: null,
            fetching: true
        }
    };
};

const pregnancyWeightGainGoalsSuccess = (success) => (state, action) => {
    return {
        ...state,
        weightGainGoals: {
            ...state.weightGainGoals,
            data: {
                ...state.weightGainGoals.data,
                weightGainGoals: action.data
            },
            fetching: false,
            success: success,
            error: !success
        }
    };
};

const handlers = {
    [UPDATE_STOP_TRACKING_REASON]: updateStopTrackingReason,
    [UPDATE_STOP_TRACKING_END_DATE]: updateStopTrackingEndDate,
    [UPDATE_STOP_TRACKING_PREGNANCY_NOTES]: updateStopTrackingPregnancyNotes,
    [UPDATE_STOP_TRACKING_CYCLE_TYPE]: updateStopTrackingCycleType,
    [RESET_STOP_TRACKING]: resetStopTracking,
    [COMPLETE_STOP_TRACKING_START]: stopTrackingUpdate(true),
    [COMPLETE_STOP_TRACKING_SUCCESS]: stopTrackingUpdate(false),
    [COMPLETE_STOP_TRACKING_ERROR]: stopTrackingUpdateFail,
    [TAKE_A_BREAK_START]: takeBreak(true),
    [TAKE_A_BREAK_SUCCESS]: takeBreak(false),
    [TAKE_A_BREAK_ERROR]: takeBreakFail,
    [RESET_TAKE_A_BREAK]: resetTakeBreak,
    [RESET_SETUP]: resetSetup,
    [UPDATE_SETUP_DUE_DATE]: updateSetupDueDate,
    [UPDATE_DAILY_HYDRATION_GOAL]: updateHydrationGoal,
    [UPDATE_WEIGHT_GOAL_USER_INPUTS]: updateWeightGoalUserInputs,
    [UPDATE_INDEX_SCALE_ADVANCED_METRICS]: updateIndexScaleAdvancedMetrics,
    [ENABLE_MOVE_ALERTS]: enableMoveAlerts,
    [ENABLE_TRAINING_STATUS_ALERTS]: enableTrainigStatusAlerts,
    [INITIAL_PREGNANCY_CREATE_SUCCESS]: createPregnancySuccess,
    [INITIAL_PREGNANCY_CREATE_ERROR]: createPregnancyError,
    [INITIAL_PREGNANCY_HYDRATION_ERROR]: createPregnancyHydrationError,
    [INITIAL_PREGNANCY_TRAINING_STATUS_ERROR]: createPregnancyTrainingStatusError,
    [INITIAL_PREGNANCY_CREATE_SEND]: createPregnancySend,
    [INITIAL_PREGNANCY_WEIGHT_GAIN_GOALS_ERROR]: createWeightGainGoalError,
    [INITIAL_PREGNANCY_INDEX_SCALE_ERROR]: createIndexScaleError,
    [INITIAL_PREGNANCY_MOVE_ALERT_ERROR]: createMoveAlertError,
    [FETCH_PREGNANCY_SNAPSHOTS_SUCCESS]: pregnancySnapshotsSuccess(true),
    [FETCH_PREGNANCY_SNAPSHOTS_FETCHING]: pregnancySnapshotsFetching,
    [FETCH_PREGNANCY_SNAPSHOTS_FAIL]: pregnancySnapshotsSuccess(false),
    [UPDATE_PREGNANCY_SNAPSHOT_UPDATING]: updatePregnancySnapshotUpdating,
    [UPDATE_PREGNANCY_SNAPSHOT_SUCCESS]: updatePregnancySnapshotSuccess(true),
    [UPDATE_PREGNANCY_SNAPSHOT_FAIL]: updatePregnancySnapshotSuccess(false),
    [FETCH_PREGNANCY_DAYVIEW_FETCHING]: dayViewFetching,
    [FETCH_PREGNANCY_DAYVIEW_SUCCESS]: dayViewSuccess(true),
    [FETCH_PREGNANCY_DAYVIEW_FAIL]: dayViewSuccess(false),
    [UPDATE_PREGNANCY_DAILY_LOG_SUCCESS]: dailyLogSuccess(true),
    [UPDATE_PREGNANCY_DAILY_LOG_FAIL]: dailyLogSuccess(false),
    [FETCH_PREGNANCY_GLUCOSE_FETCHING]: gluCoseFetching,
    [FETCH_PREGNANCY_GLUCOSE_SUCCESS]: gluCoseFetchingSuccess(true),
    [FETCH_PREGNANCY_GLUCOSE_FAIL]: gluCoseFetchingSuccess(false),
    [ADD_PREGNANCY_GLUCOSE_SUCCESS]: glucoseAddSuccess(true),
    [ADD_PREGNANCY_GLUCOSE_FAIL]: glucoseAddSuccess(false),
    [UPDATE_PREGNANCY_GLUCOSE_SUCCESS]: glucoseUpdateSuccess(true),
    [UPDATE_PREGNANCY_GLUCOSE_FAIL]: glucoseUpdateSuccess(false),
    [DELETE_PREGNANCY_GLUCOSE_SUCCESS]: glucoseDeleteSuccess(true),
    [DELETE_PREGNANCY_GLUCOSE_FAIL]: glucoseDeleteSuccess(false),
    [FETCH_PREGNANCY_ICON_SUCCESS]: pregnancyIconsSuccess(true),
    [FETCH_PREGNANCY_ICON_FAIL]: pregnancyIconsSuccess(false),
    [INITIAL_PREGNANCY_CREATE_CONFLICT_ERROR]: pregnancyConflictError,
    [FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_FETCHING]: pregnancyWeightGainGoalsFetching,
    [FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_SUCCESS]: pregnancyWeightGainGoalsSuccess(true),
    [FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_FAIL]: pregnancyWeightGainGoalsSuccess(false)
};

export default function pregnancyTracking(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) {
        return state;
    } else {
        return handler(state, action);
    }
}
